import { InvoiceSortField } from "@/graphql/codegen/graphql"

export enum InvoicesSortableAccessorKey {
  VendorInvoiceNumber = "invoiceNumber",
  Vendor = "vendorName",
  InvoiceType = "invoiceType",
  DateEntered = "dateEntered",
  DueDate = "dueDate",
  ScheduledPayDate = "scheduledPayDate",
  PaymentMethod = "paymentMethod",
  Amount = "amount",
  PrintedCheck = "printedCheck",
  Status = "status",
}

export const sortFieldToAccessorKey = new Map<InvoiceSortField, InvoicesSortableAccessorKey>([
  [InvoiceSortField.VendorInvoiceNumber, InvoicesSortableAccessorKey.VendorInvoiceNumber],
  [InvoiceSortField.VendorName, InvoicesSortableAccessorKey.Vendor],
  [InvoiceSortField.InvoiceType, InvoicesSortableAccessorKey.InvoiceType],
  [InvoiceSortField.DateEntered, InvoicesSortableAccessorKey.DateEntered],
  [InvoiceSortField.DueDate, InvoicesSortableAccessorKey.DueDate],
  [InvoiceSortField.ScheduledPayDate, InvoicesSortableAccessorKey.ScheduledPayDate],
  [InvoiceSortField.PaymentMethod, InvoicesSortableAccessorKey.PaymentMethod],
  [InvoiceSortField.Amount, InvoicesSortableAccessorKey.Amount],
  [InvoiceSortField.PrintedCheck, InvoicesSortableAccessorKey.PrintedCheck],
  [InvoiceSortField.Status, InvoicesSortableAccessorKey.Status],
])

export const accessorKeyToSortField = new Map<InvoicesSortableAccessorKey, InvoiceSortField>([
  [InvoicesSortableAccessorKey.VendorInvoiceNumber, InvoiceSortField.VendorInvoiceNumber],
  [InvoicesSortableAccessorKey.Vendor, InvoiceSortField.VendorName],
  [InvoicesSortableAccessorKey.InvoiceType, InvoiceSortField.InvoiceType],
  [InvoicesSortableAccessorKey.DateEntered, InvoiceSortField.DateEntered],
  [InvoicesSortableAccessorKey.DueDate, InvoiceSortField.DueDate],
  [InvoicesSortableAccessorKey.ScheduledPayDate, InvoiceSortField.ScheduledPayDate],
  [InvoicesSortableAccessorKey.PaymentMethod, InvoiceSortField.PaymentMethod],
  [InvoicesSortableAccessorKey.Amount, InvoiceSortField.Amount],
  [InvoicesSortableAccessorKey.PrintedCheck, InvoiceSortField.PrintedCheck],
  [InvoicesSortableAccessorKey.Status, InvoiceSortField.Status],
])
